export default {
      id: "event_temperature-usage",
      viewBox: "0 0 21 18",
      url: __webpack_public_path__ + "img/icons.svg#event_temperature",
      toString: function () {
        return this.url;
      }
    }